import { identity } from 'lodash';
import { getDefaultReportId, resolveReportIdByCampaignDimension } from '../../../../config';
import { isStaticReport } from '../../../../config/isStaticDynamicReport';
import { CUSTOM_CONTEXTUAL_REPORT_ID } from '../../config/reports/custom-contextual/customContextualReportId';
import { DYNAMIC_REPORTS_REPORT_ID } from '../../config/reports/dynamic-reports/dynamicReportsReportId';
import { PIXEL_BASED_REPORT_ID } from '../../config/reports/pixel-based/pixelBasedReportId';
import { SCHEDULED_REPORTS_REPORT_ID } from '../../config/reports/scheduled-reports/scheduledReportsReportId';

export const getMatchedReportId = ({ reportId = '', dimension, isReportVisible = identity } = {}) => {
    const reportTypeTwin = resolveReportIdByCampaignDimension(reportId, dimension);
    const newReportId = reportId !== reportTypeTwin && isStaticReport(reportTypeTwin) && reportTypeTwin;
    if (isReportVisible(newReportId)) {
        return newReportId;
    }

    const defaultReportId = getDefaultReportId(dimension);
    if (defaultReportId === CUSTOM_CONTEXTUAL_REPORT_ID && !isReportVisible(CUSTOM_CONTEXTUAL_REPORT_ID)) {
        return PIXEL_BASED_REPORT_ID;
    }

    if (defaultReportId === DYNAMIC_REPORTS_REPORT_ID && !isReportVisible(DYNAMIC_REPORTS_REPORT_ID)) {
        return SCHEDULED_REPORTS_REPORT_ID;
    }

    return defaultReportId;
};
